export default function TrustBadges() {
  const badges = [
    { icon: "ri-refresh-line", label: "Updated Weekly" },
    { icon: "ri-user-heart-line", label: "Beginner Friendly" },
    { icon: "ri-group-line", label: "Community Driven" },
    { icon: "ri-shield-check-line", label: "Verified Finds" },
  ];

  return (
    <section className="py-8 md:py-10 bg-background-100 border-y border-background-200/70">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {badges.map((b) => (
            <div key={b.label} className="flex flex-col items-center text-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${b.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}